/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Insert_Surround_Music_NoteInputs */



/**
* | output |
* | --- |
* | "Insert Surround ♪" |
*
* @param {Shortcut_Keys_Name_Insert_Surround_Music_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_insert_surround_music_note = /** @type {((inputs?: Shortcut_Keys_Name_Insert_Surround_Music_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Insert_Surround_Music_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inserer entourer ♪")
	if (locale === "de") return /** @type {LocalizedString} */ ("Insert Surround ♪")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci Surround ♪")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить объемный звук ♪")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar sonido envolvente ♪")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入环绕声 ♪")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サラウンドを挿入♪")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सराउंड साउंड डालें ♪")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir som surround ♪")
	return /** @type {LocalizedString} */ ("Insert Surround ♪")
});